module.exports = __webpack_public_path__ + "img/green-check.5d310af7.svg";